const SMS_SEND_HOLD_MS = 500;
const SMS_SEND_HOLD_MOVE_PX = 10;

function sendAtFromLocalInput(value, now = new Date()) {
  const raw = String(value || '').trim();
  if (!raw) return null;
  const when = new Date(raw);
  const current = now instanceof Date ? now : new Date(now);
  if (!Number.isFinite(when.getTime()) || !Number.isFinite(current.getTime())) {
    return null;
  }
  if (when.getTime() <= current.getTime()) return null;
  return when.toISOString();
}

function defaultScheduleLocalValue(now = new Date()) {
  const d = new Date(now.getTime() + 60 * 60 * 1000);
  d.setSeconds(0, 0);
  const pad = (n) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

function scheduledSmsNotice(iso) {
  const when = new Date(iso);
  if (!Number.isFinite(when.getTime())) return '';
  const formatted = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Detroit',
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
  })
    .format(when)
    .replace(',', '');
  return `will be sent on ${formatted}`;
}

function smsSendHoldOpened(elapsedMs, movedPx) {
  if (Number(movedPx) > SMS_SEND_HOLD_MOVE_PX) return false;
  return Number(elapsedMs) >= SMS_SEND_HOLD_MS;
}

module.exports = {
  SMS_SEND_HOLD_MS,
  SMS_SEND_HOLD_MOVE_PX,
  sendAtFromLocalInput,
  defaultScheduleLocalValue,
  scheduledSmsNotice,
  smsSendHoldOpened,
};
